import { PayloadAction } from "@reduxjs/toolkit";
import { Page } from "../../../../common/models/Page";
import { ClientsState } from "../models/ClientsState";

const setPageClients = (state: ClientsState, action: PayloadAction<Page>) => {
    state.clientsPages.page = action.payload.page;
}

export default setPageClients;